import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { LoadingAnimation } from 'src/components/global/LoadingAnimation'
import { IEvent } from 'src/graphql/generated/hooks'
import { useUpdateQueryParams } from 'src/hooks/useUpdateQueryParams'

import { EventList } from '../EventList/EventList'
import { Pagination } from '../Pagination/Pagination'

export interface EventlistitemProps {
  title: string
  logo: string
  description: string
  date: string
  updated_at: string
  city: string
  country: string
  className?: string
  slug: string
}

export interface EventPaginationProps {
  events: IEvent[]
  totalCount: number
  loading: boolean
}

export const EventPagination: React.FC<EventPaginationProps> = (props: EventPaginationProps) => {
  const router = useRouter()
  const { updateQueryParams } = useUpdateQueryParams()
  const [currentPage, setCurrentPage] = useState(1)
  const [totalCount, setTotalCount] = useState(0)
  const [currentPosts, setCurrentPosts] = useState<EventlistitemProps[]>([])
  const [postsPerPage] = useState(10)

  useEffect(() => {
    async function updatePage() {
      const curPage = router.query.page !== undefined ? parseInt(router.query.page as string) : 1
      if (props.events) {
        const posts: EventlistitemProps[] = props.events.map((event: IEvent) => ({
          title: event.title,
          description: event.description || '',
          logo: event.logo?.url || '',
          date: event.date || '',
          updated_at: event.updatedAt || '',
          city: event.city || '',
          country: event.country || '',
          slug: event.slug || '',
        }))
        setCurrentPosts(posts)
        setTotalCount(props.totalCount)
      }
      setCurrentPage(curPage)
    }
    updatePage()
  }, [currentPage, router, props])

  const navigateToPage = (page: number) => {
    updateQueryParams({ page: page.toString() }, true)
  }

  // Change page
  const paginateFront = () => {
    const lastpage = totalCount / postsPerPage
    if (currentPage < lastpage) {
      setCurrentPage(currentPage + 1)
      navigateToPage(currentPage + 1)
    }
  }
  const paginateBack = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1)
      navigateToPage(currentPage - 1)
    }
  }
  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber)
    navigateToPage(pageNumber)
  }
  return (
    <div>
      {props.loading ? (
        <LoadingAnimation></LoadingAnimation>
      ) : (
        <div className="flex flex-col flex-1">
          <EventList post={currentPosts} />
          {totalCount > 0 && (
            <Pagination
              postsPerPage={postsPerPage}
              totalPosts={totalCount}
              paginateBack={paginateBack}
              paginateFront={paginateFront}
              paginate={paginate}
              currentPage={currentPage}
              className="pt-[1.875rem]"
            />
          )}
        </div>
      )}
    </div>
  )
}
